import { render, staticRenderFns } from "./AddInvoiceTemplate.vue?vue&type=template&id=4523ae32&scoped=true"
import script from "./AddInvoiceTemplate.vue?vue&type=script&lang=js"
export * from "./AddInvoiceTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523ae32",
  null
  
)

export default component.exports